import React, { Component } from "react";
import Helmet from "react-helmet";
import urljoin from "url-join";
import config from "../../../data/SiteConfig";

class SEO extends Component {
  render() {
    const {
      postNode,
      postPath,
      postSEO,
      jobTitle,
      jobLocation,
      jobPostingSEO,
      shareLink
    } = this.props;
    let title;
    let location;
    let description;
    let image = "";
    let postURL;
    let jobPostingURL;

    if (postSEO) {
      const postMeta = postNode.frontmatter;
      title = postMeta.title;
      description = postMeta.teaser ? postMeta.teaser : config.siteDescription;
      image = postMeta.thumbAsHeader.childImageSharp.fluid.src;
      postURL = urljoin(config.siteUrl, postPath);
    } else if (jobPostingSEO) {
      location = jobLocation;
      title = jobTitle + ` in ` + jobLocation;
      image = `/images/recruiting-social-thumb.jpg`;
      description = `Sila is hiring! Learn more and apply today.`;
      jobPostingURL = shareLink;
    } else {
      title = config.siteTitle;
      image = config.siteLogo;
    }

    image = urljoin(config.siteUrl, image);
    const blogURL = `https://silasg.com/resources`;
    const schemaOrgJSONLD = [
      {
        "@context": "http://schema.org",
        "@type": "WebSite",
        url: blogURL,
        name: title,
        alternateName: config.siteTitleAlt ? config.siteTitleAlt : ""
      }
    ];
    if (postSEO) {
      schemaOrgJSONLD.push(
        {
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              item: {
                "@id": postURL,
                name: title,
                image
              }
            }
          ]
        },
        {
          "@context": "http://schema.org",
          "@type": "BlogPosting",
          url: blogURL,
          name: title,
          alternateName: config.siteTitleAlt ? config.siteTitleAlt : "",
          headline: title,
          image: {
            "@type": "ImageObject",
            url: image
          },
          description
        }
      );
    }
    return (
      <Helmet>
        {/* General tags */}
        <meta name="description" content={description} />
        <meta name="image" content={image} />
        {postSEO ? (
          <link rel="canonical" href={postURL ? postURL : blogURL} />
        ) : null}
        {jobPostingSEO ? <link rel="canonical" href={shareLink} /> : null}
        {/* Schema.org tags */}
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script>

        {/* OpenGraph tags */}
        {postSEO ? (
          <meta property="og:url" content={postURL ? postURL : blogURL} />
        ) : null}
        {jobPostingSEO ? (
          <meta
            property="og:url"
            content={shareLink ? shareLink : `https://silasg.com/openings`}
          />
        ) : null}
        {postSEO ? <meta property="og:type" content="article" /> : null}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta
          property="fb:app_id"
          content={config.siteFBAppID ? config.siteFBAppID : ""}
        />

        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:creator"
          content={config.userTwitter ? config.userTwitter : ""}
        />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />
      </Helmet>
    );
  }
}

export default SEO;
